import {Component, input, output} from '@angular/core';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {AuthenticatorModel, DeviceAuthenticatorsModel} from "../../../shared/models/authenticator.model";
import {CommonModule} from "../../../common.module";
import {ColumnMode, NgxDatatableModule, SelectionType} from "@swimlane/ngx-datatable";
import {TooltipDirective} from "ngx-bootstrap/tooltip";

@Component({
  selector: 'app-device-authenticators',
  standalone: true,
  imports: [
    FaIconComponent,
    NgIf,
    TranslatePipe,
    NgSwitchCase,
    NgSwitch,
    NgSwitchDefault,
    CommonModule,
    NgxDatatableModule,
    TooltipDirective
  ],
  templateUrl: './device-authenticators.component.html',
  styleUrl: './device-authenticators.component.scss'
})
export class DeviceAuthenticatorsComponent {
  deviceAuthenticator = input.required<DeviceAuthenticatorsModel>();
  hideRemoveAuthenticatorsButton = input.required<boolean>();
  iconMapping = input.required<any>();
  isSynchronizing = input.required<any>();

  onBlockDeviceEvent = output<DeviceAuthenticatorsModel>()
  onUnblockDeviceEvent = output<DeviceAuthenticatorsModel>()
  onRemoveDeviceEvent = output<DeviceAuthenticatorsModel>()
  onSyncEntraPasskeys = output<string>()
  onResetPin = output<void>()
  onRemoveAuthenticator = output<any>()

  protected readonly SelectionType = SelectionType;
  protected readonly ColumnMode = ColumnMode;

  onBlockDevice(deviceAuthenticators: DeviceAuthenticatorsModel) {
    this.onBlockDeviceEvent.emit(deviceAuthenticators);
  }

  onUnblockDevice(deviceAuthenticators: DeviceAuthenticatorsModel) {
    this.onUnblockDeviceEvent.emit(deviceAuthenticators);
  }

  onRemoveDevice(deviceAuthenticators: DeviceAuthenticatorsModel) {
    this.onRemoveDeviceEvent.emit(deviceAuthenticators);
  }

  resetPin() {
    this.onResetPin.emit();
  }

  syncPasskeys(id) {
    this.onSyncEntraPasskeys.emit(id);
  }

  removeAuth(row: AuthenticatorModel) {
    this.onRemoveAuthenticator.emit(row);
  }
}
